<a class="whatsapp" [href]="'http://wa.me/55' + empresa?.whatsapp" [class.light]="light">
  <i class="fab fa-whatsapp mr-1" [class.fa-2x]="!light"></i>
  <ng-container *ngIf="empresa && empresa.whatsapp && empresa.whatsapp.length === 11">
    {{empresa?.numeroWhatsapp?.whatsapp | mask: '(99) 9-9999-9999'}}
  </ng-container>
  <ng-container *ngIf="empresa && empresa.whatsapp && empresa.whatsapp.length === 10">
    {{empresa?.numeroWhatsapp?.whatsapp | mask: '(99) 9999-9999'}}
  </ng-container>
</a>
